export default "__VITE_ASSET__BuLIWgOK__"